import type { Locale } from "@/lib/i18n/config";

type LocaleFlagProps = {
	locale: Locale;
	className?: string;
};

export function LocaleFlag({ locale, className }: LocaleFlagProps) {
	const cls = `${className ?? "h-5 w-5"} overflow-hidden rounded-full`;

	if (locale === "id") {
		return (
			<svg
				viewBox="0 0 24 24"
				className={cls}
				role="img"
				aria-label="Bendera Indonesia"
				focusable="false"
			>
				<title>Bendera Indonesia</title>
				<rect x="0" y="0" width="24" height="12" fill="#e70011" />
				<rect x="0" y="12" width="24" height="12" fill="#ffffff" />
				<circle
					cx="12"
					cy="12"
					r="11.5"
					fill="none"
					stroke="rgba(15, 23, 42, 0.15)"
					strokeWidth="1"
				/>
			</svg>
		);
	}

	return (
		<svg
			viewBox="0 0 24 24"
			className={cls}
			role="img"
			aria-label="United States flag"
			focusable="false"
		>
			<title>United States flag</title>
			<rect x="0" y="0" width="24" height="24" fill="#ffffff" />
			<rect x="0" y="1.7" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="5.1" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="8.5" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="11.9" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="15.3" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="18.7" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="22.1" width="24" height="1.7" fill="#bf0a30" />
			<rect x="0" y="0" width="10" height="10" fill="#002868" />
			<circle
				cx="12"
				cy="12"
				r="11.5"
				fill="none"
				stroke="rgba(15, 23, 42, 0.15)"
				strokeWidth="1"
			/>
		</svg>
	);
}
